var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDistance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Distance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_Distance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(4.000000, 2.000000)",
    fill: "#666666",
    stroke: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,8.85714286 C4.42300557,8.85714286 3.14285714,7.57699443 3.14285714,6 C3.14285714,4.42300557 4.42300557,3.14285714 6,3.14285714 C7.57699443,3.14285714 8.85714286,4.42300557 8.85714286,6 C8.85714286,7.57699443 7.57699443,8.85714286 6,8.85714286 M6,2 C3.79487179,2 2,3.79487179 2,6 C2,8.20512821 3.79487179,10 6,10 C8.20512821,10 10,8.20512821 10,6 C10,3.79487179 8.20512821,2 6,2",
    id: "Fill-1",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00166759,11.206594 C7.90439133,12.8438254 6.66703724,14.3523753 5.99666481,15.1449384 C5.44635909,14.4983674 4.15230684,12.9411187 2.99499722,11.2101047 C1.55753196,9.06190107 0.800444691,7.35174311 0.800444691,6.25680264 C0.800444691,3.26744138 3.13507504,0.837681594 6,0.837681594 C8.86492496,0.837681594 11.1995553,3.27088262 11.1995553,6.25680264 C11.1995553,7.34475634 10.4391329,9.05842507 9.00166759,11.206594 M6,0 C2.69149528,0 0,2.80509843 0,6.25329188 C0,7.53593642 0.787103947,9.3643132 2.33796554,11.6828062 C3.55864369,13.5077069 4.92273485,15.1344756 5.44969427,15.7497279 C5.5897721,15.9131 5.78654808,16 5.99666481,16 C6.20678155,16 6.40355753,15.9131 6.54363535,15.7497279 C7.21400778,14.9641863 8.50806003,13.3929989 9.65536409,11.6793649 C11.2095609,9.35736119 12,7.53246042 12,6.24981588 C12,2.80162242 9.30850472,0 6,0",
    id: "Fill-3",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDistance);
export default __webpack_public_path__ + "static/media/ic_distance.7447db3574656216bd4a7b098659f75a.svg";
export { ForwardRef as ReactComponent };